/**
 * OhMy Scrolling-Text: Parallax-Neigung.
 * Das Band neigt sich beim Scrollen dynamisch: unten im Viewport = +Winkel,
 * Mitte = 0°, oben = -Winkel. Die Stärke kommt aus dem Neigungs-Regler
 * (data-ohmy-tilt-parallax); 0° = sanfte Standard-Stärke von 3°.
 * Respektiert prefers-reduced-motion (dann statische Neigung).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var bands = document.querySelectorAll('[data-ohmy-tilt-parallax]');
  if (!bands.length) return;

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    bands.forEach(function (band) {
      var rect = band.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) return;
      var maxTilt = parseFloat(band.dataset.ohmyTiltParallax);
      if (!maxTilt) maxTilt = 3;
      // Fortschritt durch den Viewport: +1 (unten) .. 0 (Mitte) .. -1 (oben)
      var progress = ((rect.top + rect.height / 2) - vh / 2) / (vh / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      band.style.setProperty('--ohmy-tilt', (maxTilt * progress).toFixed(2) + 'deg');
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
